module.exports = {
  apps:{
    threejs: {
      bigFileMsg: '',
      creatingGeometry: 'Создание геометрии...',
      error: 'Ошибка',
      downloadFileMb: 'Загрузка файла: %{mb} MБ',
      drawNumLayers: 'Визуализировано: %{num} слоев...',
      loadingInfo: 'Загрузка информации...',
      couldntLoadURLErrorCode: 'Не удалось загрузить URL, код ошибки: ',
      couldntLoadURL: 'Не удалось загрузить URL ',
      waitingFileConversion: 'Ожидание конвертации файла',
      loadingModelInfillPart: 'Загружаются внутренние части обьекта ',
      loadingModelWallsPart: 'Загрузка стен модели. Часть ',
      loadingPart: 'Загружается часть ',
      conversionFileError: 'Ошибка при конвертации модели',
      fileCanCrashBrowser: 'Вы пытаетесь открыть файл более %{mb} мегабайт. Браузер может перестать отвечать из-за этого. ',
      loadAnyway: 'Все равно загрузить',
      nav: {
        translate: 'Подвинуть (M)',
        rotate: 'Повернуть (R)',
        scale: 'Изменить размер (C)',
        onbed: 'Put on bed (Z)',
        center: 'Center object (A)',
        selectObjExtruder: 'Select object extruder',
        cameraTop: 'Top camera (T)',
        add: 'Загрузить файл (N)',
        save: 'Отслайсить (ctrl+S)',
        gcodePrint: 'Print file (p)',
        undo: 'Отмена (ctrl+Z)',
        redo: 'Отмена (ctrl+Y)',
        fullscreenPopup: 'Fullscreen (ctrl+F)',
        minimizePopup: 'Minimize (ctrl+M)',
        ruler: 'Отобразить линейку (ctrl+H)',
        space: 'Toggle transform axis (Q)',
        snap: 'Магнитить по сетке (V)',
        planecube: 'Куб рабочей платформы (B)',
        removeObj: 'Удалить обьект (D)',
        showhideObj: 'Показать/Спрятать обьект',
        copy: 'Копировать обьект (ctrl+D)',
        rename: 'Переименовать обьект',
        selectExtruder: 'Выбрать экструдер',
        wireframeMode: 'Режим каркаса',
        showhide: 'Отобразить сетку (G)',
      }
    },
    upload:{
      dad: 'Перетащите чтобы загрузить модель',
      select: 'Выбрать с компьютера'
    },
    magicFix:{
      appName: 'Волшебная палочка',
      fixModel: 'Починить'
    },
    toolpath:{
      Printer: 'Принтер',
      Camera: 'Камера',
      front:'Спереди',
      back: 'Сзади',
      right: 'Справа',
      left: 'Слева',
      top: 'Сверху',
      bottom: 'Снизу',
      onObject: 'На объект',
      viewLayers: 'Смотреть слои',
      info: 'Информация',
      speed: 'Скорость',
      mm: 'мм',
      min: 'мин',
      ext: 'Экстр',
      laers: 'Слои',
      range: 'Промежуток',
      height: 'Высота',
      extrusion: 'Экструзия',
      showServiceParts: 'Показать служебные части',
      showMotion: 'Показать движение',
      animation: 'Анимация',
      filament: 'Пластик',
      estimatedPrintTime: 'Оценочное время печати',
      raft :'Рафт',
      extruder: 'Экструдер',
      analyze: 'Анализ',
      supports: 'Поддержки',
      temperature: 'Температура',
      duration: 'Длительность',

      // new
      loading: 'Загрузка',
      fileInfo: 'Информация о файле',
      fileId: 'ID файла',
      fileName: 'Имя файла',
      printingDuration: 'Длительность печати',
      heatedDedTemperature: 'Температура платформы',
      showExtrusion: 'Показать экструзию',
      showInfill: 'Показать заполнение',
      appName: 'Визуализатор',

      ExTemp1:"Температура 1го экструдера:",
      ExTemp2:"Температура 2го экструдера:",
      ExMat1:"Mатериал 1го экструдера:",
      ExMat2:"Mатериал 2го экструдера:",
      yes: 'да',
      no: 'нет',
      notavail: 'н/д',
      meter: 'м',
      mmPerSecond: 'мм/с',
      gram: 'г',
      max: 'макс.',
      hour: 'ч',
      extruderNumFilament: 'Экструдер %{num} пластик',
      cost: 'Цена',
      objectExtendsBeyondBed: 'Объект выходит за пределы платформы',
    },
    editor:{
      sliceInfo: 'Параметры Слайсинга',
      move: 'Подвинуть',
      rotate: 'Повернуть',
      scale: 'Изменить размер',
      undo: 'Отмена',
      extrra: 'Дополнительно',
      addFiles: 'Добавить файл',
      position: 'Позиция',
      update: 'Применить',
      reset: 'Сбросить',
      onBed: 'Расположить',
      center: 'По-центру',
      optimalRatete: 'Оптимальный поворот',
      inch: 'Дюймы',
      maxBedZize: 'Макс размер',
      keepProportions: 'Сохранить ',
      firstExtruder: 'Первый экструдер',
      secondExtruder: 'Второй экструдер',
      apply: 'Применить',

      // new
      extruder: 'Экструдер',
      free: 'Свободная',
      addFile: 'Загрузить файл',
      slice: 'Отслайсить',
      selectExtruder: 'Выбрать экструдер',
      copy: 'Копировать',
      quantity: 'Количество',
      selectFile: 'Выбрать файл',
      singleFile: 'Из моих файлов',
      refresh: 'Обновить',
      resetRotate: 'Сбросить поворот',
      scaleTo: 'Изменить размер',
      resetScale: 'Сбросить',
      align: 'Разместить все',
      appName: 'Редактор',
      hide: 'Спрятать',
      rename: 'Переименовать',
      mirror: 'Отзеркалить по',
      centered: 'Отцентровать',
      selectDefLable:'Одиночный файл со страницы файлов',

      newName: 'Новое имя',
      show: 'Показать',
      youCantRemoveLastObject: 'Вы не можете удалить последний объект',
      projects: 'Проекты',
      objectBiggerPrinterBox: 'Объект больше рабочей платформы',
      objectsOutPrinterBox: 'Обьекты %{objs} находятся вне рабочей платформы',
      objectOutPrinterBox: 'Обьект вне рабочей платформы',
    },
    slicer: {
      simple: 'Быстрые',
      advanced: 'Продвинутые',
      expert: 'Экспертные',
      price: 'Цена',
      save: 'Сохранить слайсинг профиль',
      slicerSettingsFor: 'Параметры слайсинга для',
      selectPrinterType: 'Выбрать тип принтера',
      selectSlicingProfile: 'Выбрать слайсинг профиль',
      layerThickness : 'Высота слоя',
      shellThickness: 'Толщина стенки',
      infill: 'Плотность заполнения',
      table: 'Платформа',
      platfAdhesion: 'Тип прилипания к столу',
      supports: 'Генерация поддержек',
      reCenter: 'Отцентровать перед слайсингом',
      material: 'Mатериал',
      cooling: 'Охлаждение',
      nozzleDiameter:  'Диаметр сопла',
      filamentFlow: 'Поток материала',
      quality: 'Качество',
      bottomTopThick: 'Толщина нижнего/верхнего',
      brimLineAmount: 'Количество Брим полос',
      printSpeed: 'Скорость печати',
      bottomLayerSpeed: 'Скорость первого слоя',
      travelingSpeed: 'Скорость передвижения',
      retractionDistance: 'Скорость отката',
      heatedBed: 'Нагрев платформы',
      fanSpeedMin: 'Мин. скорость вентилятора',
      fanSpeedMax: 'Макс. скорость вентилятора',
      fanFullOnHeight: 'Обычная скорость вентилятора на высоте',
      minimalLayer: 'Минимальное время слоя(сек)',
      coolingFan: 'Включить вентиляторы',
      // new
      openSTLEditor: 'Открыть STL редактор',
      longer: 'дольше',
      weak: 'слабее',
      light: 'легче',
      faster: 'быстрее',
      strong: 'прочнее',
      size: 'Размер',
      appName: 'Cлайсер',

    }
  },

  firstLogin: {
    hello: 'Привет! Вы находитесь в приложении Diaprint Cloud.',
    toGetTheActivation: 'Для получения кода активации и начала работы привяжите ваш 3D принтер к аккаунту Diaprint:',
    goTo: 'Зайдите в раздел “Принтеры”',
    pressBtn: 'Нажмите кнопку “Добавить принтеры”',
    enterSnNumber: 'Введите серийный номер и получите код активации',
    addActive: 'Активируйте 3D принтер при помощи кода',
    close: 'Закрыть',
    addPrinter: 'Добавить принтер'
  },

  login:{
    signIn: 'Войти',
    signUp: 'Зарегистрироваться',
    sso: 'SSO',
    btn:{
      back:'Назад'
    },
    or: 'Или',
    password: 'Пароль',
    confirmYourEmail: 'Подтвердите вашу почту',
    passwordReset: ' Сбросить пароль',
    forgotPassword:'Забыли пароль?',
    notActivated: 'Ссылка для активации аккаута была выслана на электронную почту',
    selectSchool: 'Выберите школу, университет или компанию',
    enterWith: 'Войти через',
    email: 'Электронная почта',
    firstName:'Имя',
    lastName:'Отчество',
    phone: 'Телефон (+79150000001)',
    phoneTitle: 'Введите телефон в формате +7ХХХХХХХХХХ',
    company: 'Компания',
    repeatPassword:'Повторите пароль',
    createAccount: 'Создать аккаунт',
    minSymbols: 'Мин. %{count} символов',
    reset: 'Сбросить',
    goTo3DPos: 'Перейти в Diaprint',
    enterYourAccountEmail: 'Введите email вашего аккаунта',
    resendEmail: 'Повторить отправку',
    ifYouDoreceiveTheEmail: 'Если вы не получили сообщение на почту, нажмите Повторить отправку',
    iHaveRead:  'Я прочитал <a href="%{termsOfService}" target="_blank"> Условия Использования</a> и <a href="%{privacyPolicy}" target="_blank">Политику конфиденциальности</a>  и даю все согласия.',
    iAgree:  'Я согласен предоставить Email адрес для идентификации пользователя в 3DPrinterOS облаке и IP адрес в целях безопасности',
    iAm: 'Я старше 16 лет/Я родитель ребенка младше 16 лет и даю разрешение на использование DiaPrint Облака.',
    iGreeToAhare: 'Я согласен предоставить информацию о моем месте работы. Она поможет DiaPrint облако продвигать свои сервисы',
    no_gdpr: 'Мы не можем создать аккаунт без вашего согласия на обработку персональных данных',
    captcha_not_valid: 'reCaptcha токен не валидный',
    repeatPasswordNotNeeded: 'Повторный ввод пароля не нужен. Запомните, тот что вы ввели',
    checkEmailForPasswordReset: 'Письмо с ссылкой для сброса пароля выслано на указанную электронную почту',
    beSureToReLogin: 'Новый пароль успешно сохранен',
    verification: {
      title: 'Верификация',
      firstDesc: '1. Откройте приложение Google Authenticator на вашем телефоне',
      secondDesc: '2. Найдите аккаунт "3DPrinterOS %{email}"',
      thirdDesc: '3. Введите код верификации внизу',
      code: 'Код верификации',
      verify: 'Подтвердить'
    },
  },
  profiles:{
    tabs: {
      active: 'Активные',
      deleted: 'Удаленные',
      default: 'Дефолтные'
    },
    buttons: {
      'addProfile': 'Cоздать профиль'
    },
    actions: {
      access: 'Управление доступом',
      edit: 'Изменить',
      restore: 'Восстановить',
      makeDefault: 'Сделать дефолтным',
      removeDefault: 'Перенести в мои профили'
    },
    search: 'Поиск',
    confirmRestore: 'Вы уверены, что хотите восстановить профиль?',
    failedRestore: 'Ошибка восстановления профиля:',
    makeAsDefaultButton: 'Сделать дефолтным',
    makeDefaultNamePopupText: 'Вы уверены, что хотите сделать профиль стандартным? Им смогут воспользоваться все пользователи ПО.',
    makeDefaultNamePopupNameField: 'Введите имя дефолтного профиля',
    confirmMakeDefaultReplace: 'Дефолтный профиль с именем %{name} уже существует. Вы уверены что хотите заменить профиль?',
    confirmRemoveAfterMakeDefault: 'Профиль успешно был сохранен как дефолтный. Удалить профиль из списка?',
    failedToDeleteProfile: 'Ошибка удаления профиля',
    confirmDeleteDefaultProfile: 'Вы уверены, что хотите удалить стандартный профиль?  Пользователи ПО не смогут им больше воспользоваться.'
  },
  files: {
    size:{
      b:'б',
      kb: 'кб',
      mb:'мб',
      gb:'гб',
      tb: 'тб',
    },
    apps: {
      layout: 'Расположить',
      preview: 'Визуализация'
    },
    base:{
      files: 'Файлы',
      selected: 'выбрано',
      email: 'Электронная почта',
      add: 'Добавить',
      workgroup: "Рабочая группа",
      selectPrinters:'Выберите 3Д принтер',
      print: 'Напечатать',
      title: 'Имя',
      apps: 'Приложения',
      actions: 'Действия',
      selectAll: 'Выбрать все',
      selectUnSelectAll: 'Снять все',
    },
    msg:{
      noJobsWasExecutedForTheFile:'Для файла не выполнялось никаких заданий',
      fileDeleteTooltips: 'Удален. У вас есть возможность восстановить файл до следующего открытия сайта.'
    },
    shareFiles:{
      unsharingFailed: 'Не удалось отменить совместное использование',
      failedtoUnshareFile: 'Не удалось отменить общий доступ к файлу',
      fileOwnerBeremove: 'Нельзя удалить владельца файла',
      invalidEmail: 'Неверный адрес электронной почты'
    },
    action:{
      addFiles:'Загрузить файл',
    },
    multiActions: {
      moveToProject: 'Отправить в проект',
      copyToProject: 'Копировать в проект',
    },
    modal:{
      moveFilesToProject:'Отправить файлы в проект',
      copyFilesToProject:'Копировать файлы в проект',
      repair:{
        info:'Используйте волшебную палочку чтобы автоматически подготовить модель для 3Д Печати. Волшебная палочка конвертирует Cad файлы в Stl, анализирует, чинит и поворачивает файлы для печати именно на Вашем 3д принтере.',
        notes: 'На заметку: Поддерживаются только 3ds, 3mf, amf, obj и stl форматы.',
        moveObject: 'Подвинуть объект в центр стола',
        rotateObject: 'Повернуть объект для расположения на конкретной платформе',
        autoSize: 'Автоматически изменить размер модели*',
        scaleObject: '*Уменьшает объекты больше 50 см в 10 раз. Увеличивает объекты меньше 2мм в 10 раз.',
      },
      fileEdit:{
        defaultSlicingProfiles: 'Стандартные слайсинг профили',
        publicSharing: 'Сделать публичным',
        allowToDisplayInSearch: 'Показывать в Search'
      },
    },
    navbar: {
      files: 'Файлы',
      projects: 'Проекты',
      profiles: 'Профили',
    },
    typeTooltip: {
      loading: 'Загружается...',
      unavailable: 'Данные о файле не доступны',
      maxDimensions: 'Максимальные размеры',
      na: 'н/п',
      modelVolume: 'Объем модели',
      printerType: 'Тип принтера',
      layerHeight: 'Высота слоя',
      extruders: 'Экструдеры',
      bedTemperature: 'Температура платформы',
      length: 'Длина',
      cost: 'Цена',
      weight: 'Вес',
      estimatedTime: 'Оценочное время'
    },
    selectPrinterType: 'Тип принтера',
    printers: 'Принтеры',
    download: 'Скачать',
    support: 'Поддержка',
  },
  menu: {
    history: 'История',
    files: 'Файлы',
    profiles: 'Профили',
    printers: 'Принтеры',
    download: 'Скачать',
    support: 'Поддержка',
  },
  buttons: {
    add: 'Добавить',
    edit: 'Изменить',
    ok: 'OK',
    cancel: 'Отмена',
    close: 'Закрыть',
    save: 'Сохранить',
    removed: 'Удалить',
    download: 'Скачать',
    unshare: 'Отвязать',
    delete: 'Удалить',
    share: 'Поделиться',
    stop: 'Остановить',
    undo: 'Отменить',
    deleted: 'Удален',
    submit: 'Отправить',
    print: 'Напечатать'
  },
  projects:{
    delete: 'Вы собираетесь %{action} проект %{projectName} , подтвердите свое действие.'
  },
  printers: {
    status: {
      idle: 'готов',
      bed_not_clear: 'Платформа не пустая',
      printing: 'печатает',
      heating: 'нагревается',
      paused: 'пауза',
      offline: 'отключен',
      manual_control: 'ручной режим',
      cancelling_print: 'отмена печати',
      notconnected: 'не подключен',
      printing_locally: 'локальная печать',
      error: 'ошибка',
      connecting: 'подключение',
      downloading: 'загрузка',
      Virtual: 'индустриальный',
      local_mode: 'локальный режим',
      change_filament: 'смена пластика'
    },
    navbar: {
      printers: 'Принтеры',
      liveViewWall: 'Камеры',
      search: 'Поиск',
      addPrinter: 'Добавить принтер',
      activePrinters: 'Активные принтеры',
      activePrintersByHost: 'Активные принтеры сгруппированные по хосту',
      inactivePrinters: 'Неактивные принтеры',
      createIndustrialPrinter: 'Создать индустриальный принтер',
      addWorkgroupPrinters: 'Добавить принтеры рабочей группы'
    },
    buttons: {
      connectToWorkgroup: 'Подключиться к рабочей группе'
    },
    form: {
      addNew: {
        title: 'Выберите тип и модель Вашего 3D принтера',
        selectPrinterType: 'Выберите тип принтера',
        remove: 'Удалить',
        addPrinters: 'Добавить принтеры',
        errorTitle: 'Ошибка добавления принтера'
      },
      addIndustrial: {
        title: 'Добавление индустриального принтера / CNC машины'
      }
    },
    disconnected: {
      waitingConnection: 'Ожидает подключение',
      token: 'Ключ',
      tokenTooltip: 'Введите ключ, указанный на экране Вашего 3D принтера. Вы можете найти 3DPrinterOS Cloud подключение в настройках',
      howToGet: 'как использовать',
      connect: 'Подключение',
      notSupportedText: 'Эта модель принтера не поддерживается и не может быть подключена напрямую. Пожалуйста, <span>обратитесь в службу поддержки</span> для добавления принтера.',
      connectInstruction: 'Следуйте <a target="_blank" href="%{link}">инструкции</a> для подключения принтера',
      runClient: 'Запустите <a target="_blank" href="%{downloadLink}">3DPrinterOS клиент</a> и следуйте инструкциям для подключения принтера',
      connectPrinterToInternet: 'Подключите принтер в интернет',
      remove: 'Удалить',
      makeIndustrial: 'Сделать индустриальным',
      regErrorTitle: 'Ошибка регистрации принтера',
      regErrorByCode: 'Произошла ошибка при попытке подключить принтер по коду',
      removeErrorTitle: 'Ошибка удаления принтера',
      removeError: 'Произошла ошибка при попытке удалить принтер'
    },
    inactive: {
      noPrinters: 'Неактивные принтеры отсутствуют',
      delete: 'Удалить',
      unhide: 'Восстановить',
      restoreErrorTitle: 'Ошибка восстановления принтера',
      restoreError: 'Произошла ошибка при попытке восстановить принтер'
    },
    item: {
      queue: 'Очередь',
      printing: 'Печать',
      job: 'задач | задача | задачи | задач',
      share: 'Поделиться',
      printerSettings: 'Настройки принтера',
      printerLog: 'Логи принтера',
      jobSorting: 'Ручная сортировка задач',
      finishJobSorting: 'Завершить сортировку задач',
      moveAllJobs: 'Перенести все задачи',
      buildTrayIsClear: 'Платформа свободна',
      clearBuildTrayErrorTitle: 'Ошибка очистки платформы',
      clearBuildTrayError: 'Произошла ошибка при попытке очистить платформу',
      flags: {
        doorOpen: 'Открыта дверца',
        noFilament: 'Нет пластика',
        filamentClogged: 'Засорение пластиком',
        bedNotClear: 'Платформа не пустая'
      },
      buttons: {
        closeWithoutSaving: 'Закрыть без сохранения',
        saveChanges: 'Сохранить изменения'
      },
      timeLeft: 'Осталось',
      extruder: 'Экструдер',
      ext1: 'Экструдер 1',
      ext2: 'Экструдер 2',
      heatBed: 'Нагрев платформы',
      chamb: 'Камера',
    },
    camera: {
      noCamera: 'Нет камеры',
      cameraName: 'Камера %{num}'
    },
    select: {
      fav: 'Часто используемые принтеры',
      my: 'Мои принтеры',
      all: 'Все принтеры'
    },
    host: {
      localIp: 'Локальный IP',
      macAddress: 'MAC адрес',
      versionWarning: 'Пожалуйста, скачайте и обновите последнюю (%{lastVer}) версию 3DPrinterOS клиента. Ваша текущая версия устарела.',
      versionWarningDetailed: 'Пожалуйста, скачайте и обновите последнюю (%{lastVer}) версию 3DPrinterOS клиента. Ваша текущая версия %{userVer} устарела.'
    },
    job: {
      pause: 'Пауза',
      start: 'Старт',
      restart: 'Печать заново',
      resume: 'Восстановить',
      finish: 'Завершить',
      cancel: 'Отмена',
      error: 'Ошибка',
      details: 'Детали',
      download: 'Скачать',
      copy: 'Копировать',
      notes: 'Заметки',
      buildTrayIsNotClearTooltip: 'Платформа занята',
      printErrorTitle: 'Ошибка печати',
      confirmPause: 'Вы уверены, что хотите приостановить печать? Это может привести к дефектам печати.',
      confirmPrintError: 'Пожалуйста, подтвердите ошибку при печати?',
      denyFilename: 'Извините, у Вас нет доступа для просмотра имени файла',
      denyAuthor: 'Извините, у Вас нет доступа для просмотра данных автора',
      status: {
        queue: 'В очереди',
        progress: 'В процессе',
        pause: 'Пауза',
        failed: 'Неудачная',
        failedStreaming: 'Неудачная (ошибка потоковой передачи)',
        failedSuspiciousActivity: 'Неудачная (подозрительная деятельность)',
        aborted: 'Прервана',
        finished: 'Завершена',
        unknown: 'Неизвестно'
      },
      transaction: {
        refund: 'Возврат',
        withdraw: 'Списание',
        newCost: 'Новая стоимость',
        desc: 'Описание',
        update: 'Изменить',
        noteText: 'Вы можете изменить стоимость печати на этой странице. Разница будет вычтена или добавлена в выставленном счете.',
        loadingError: 'Ошибка при загрузке списка транзакций',
        errorLess0: 'Стоимость не может быть меньше нуля.',
        errorCostNotDiffer: 'Новая стоимость не отличается от текущей.',
        confirmRefund: 'Вы уверены что хотите сделать возврат владельцу задачи %{currency}%{amount}?',
        confirmWithdraw: 'Вы уверены что хотите списать с владельца задачи %{currency}%{amount}?',
        errorMessage: 'Ошибка создания транзакции',
        transType: 'Тип',
        amount: 'Сумма',
        date: 'Дата',
        comment: 'Комментарий',
        createTransaction: 'Создать транзакцию'
      }
    },
    modal: {
      addIndustrial: {
        printerType: 'Тип 3D принтера / CNC',
        selectPrinterType: 'Выберите тип принтера',
        printerHost: 'Хост 3D принтера / CNC',
        selectPrinterHost: 'Выберите хост',
        printerName: 'Имя 3D принтера / CNC',
        addRandomHost: 'Добавить случайно генерируемый хост',
        activeHostGroup: 'Активные хосты',
        otherHostGroup: 'Другие хосты',
      },
      cancellationReason: {
        title: 'Почему Вы отменяете задачу? Пожалуйста, выберите одну или более причин:',
        hardwareIssues: 'Проблемы с аппаратной частью 3D принтера:',
        slicerIssues: 'Проблемы слайсинга:',
        designIssues: 'Проблемы дизайна / модели:',
        describeProblemMore: 'Пожалуйста, опишите более подробно с какой проблемой Вы столкнулись?',
        notifyJobOwner: 'Так же оповестить владельца задачи по электронной почте',
        reasons: {
          nozzleClogged: 'Засорилось сопло',
          bedCalibration: 'Калибровка платформы',
          notSticking: 'Первый слой не прилип к кровати',
          underextrusion: 'Недоэкструзия',
          mechanical: 'Неисправность механической части',
          electrical: 'Неисправность электрической части части',
          firmwareIssue: 'Проблемы прошивки принтера',
          filamentLack: 'Потек пластик',
          slicerSettings: 'Неправильные слайсинг настройки',
          slicingQuality: 'Плохое качество слайсинга',
          printingSpeed: 'Неправильная скорость печати',
          printingTemperature: 'Неправильная температура печати',
          position: 'Неправильная позиция детали на лотке',
          file: 'Неверный файл',
          dontNeed: 'Эта печать не актуальна',
          anotherPrint: 'Есть другая, более приоритетная задача',
          size: 'Модель слишком большая/маленькая'
        }
      },
      choosePrinter: {
        move: 'Перенести',
        copy: 'Копировать',
        print: 'Печать',
        queue: 'Очередь',
        shareLabel: 'Поделиться принтером с владельцем печати только с возможностью смотреть его статус',
        errorLoadingJobData: 'Ошибка при получении данных задачи',
        errorCopyJob: 'Ошибка копирования задачи',
        errorMoveJob: 'Ошибка переноса задачи',
        errorQueueJob: 'Ошибка добавления задачи в очередь',
        errorQueueMultipleJobs: 'Ошибка добавления следующего файла(ов) в очередь: %{filenames}',
        errorRestartJob: 'Ошибка перезапуска печати',
        successQueue: 'Ваш запрос был отправлен и ожидает одобрения.',
        successPrint: 'Ваш запрос был отправлен.',
        goToPrinters: 'На страницу принтеров',
        selectPrinter: 'Select printer',
        addNote: 'Add a note',
        choose3dPrinter: 'Choose 3D printer',
        qaNotValid: 'Please set values for all required fields',
        noPrinters: 'There are no available printers',
        buildTrayNotClear: 'Build tray is not clear',
        filamentNotEnough: 'Filament not enough',
        queueDisabled: 'The queue is disabled for this printer'
      },
      confirmJobCancel: {
        title: 'Вы собираетесь отменить печать %{fileName} на %{printerName}',
        errorCancelJob: 'Ошибка отмены задачи %{jobId}',
        cancelJob: 'Отменить задачу',
        back: 'Назад'
      },
      confirmDeletePrinter: {
        deleteWarning: 'Вы собираетесь удалить принтер',
        deleteWarningIndustrial: 'Вы собираетесь удалить <span class="text-danger">индустриальный</span> принтер',
        forAllUsers: ' для всех пользователей.',
        fromYourAccount: ' из Вашего аккаунта',
        confirmAction: 'Пожалуйста, подтвердите действие.',
        ps: 'ВНИМАНИЕ! Будьте осторожны, Вы не сможете отменить это действие. Принтер будет удален у всех, с кем Вы им поделились. Все задачи в очереди будут утеряны навсегда.',
        psAdmin: 'Принтер будет убран из всех рабочих групп и будет удален для всей организации.',
        affectedPrinter: 'Затронутые принтера',
        errorDeletePrinter: 'Ошибка удаления принтера',
        delete: 'Удалить'
      },
      editHost: {
        title: 'Название',
        location: 'Локация',
        colour: 'Цвет',
        setLocation: 'Выбрать локацию',
        errorEditHost: 'Ошибка редактирования имени хоста',
        errorEditColor: 'Ошибка редактирования цвета хоста'
      },
      jobDetails: {
        logs: 'Логи',
        summary: 'Общее',
        notes: 'Записи',
        settings: 'Настройки',
        timelaps: 'Видео',
        transactions: 'Транзакции',
        noTimelaps: 'Нет видео',
        settingsUnavailable: 'Настройки слайсинга недоступны. Для этого файла не запускался слайсер',
        noSettings: 'Нет настроек слайсера',
        errorLoadingSettings: 'Ошибка загрузки настроек слайсинга',
        noLogs: 'Нет логов',
        errorLoadingLogs: 'Ошибка загрузки логов',
        openToolpath: 'Открыть в Визуализаторе',
        openStlEditor: 'Открыть в STL редакторе',
        estimatedTime: 'Оценочное время',
        filament: 'Пластик',
        status: 'Статус'
      },
      jobNotes: {
        qa: 'Вопросы и ответы',
        notePlaceholder: 'Введите текст',
        types: {
          note: 'Заметка',
          feedback: 'Отзыв'
        },
        addNote: 'Добавить',
        errorLoadingNotes: 'Ошибка при загрузке заметок',
        errorAddNote: 'Ошибка добавления заметки'
      },
      printerSettings: {
        announcement: 'Объявление',
        announcementPlaceholder: 'Сообщение, которое отображается в строке статуса принтера',
        filamentTracking: 'Отслеживание пластика',
        filament: {
          left: 'Остаток',
          nozzle: 'Сопло'
        },
        displayTitle: 'Отображаемое имя',
        active: 'Активный',
        enableQueue: 'Включить очередь',
        enableClearBed: 'Отслеживать свободность рабочей платформы',
        forRpiGPIO: 'Для Raspbery Pi GPIO',
        startNextJobButton: 'Кнопка запуска следующей задачи',
        camera: 'Камера',
        dualCamera: 'Стандартная',
        piCamera: 'PI',
        multiCamera: 'Мульти',
        resetModule: 'Сбросить модуль камеры',
        delete: 'Удалить',
        yourEmail: 'Ваш адрес электронной почты',
        removePrinter: 'Удалить принтер',
        owner: 'Владелец',
        changeAccountNote: 'Этот аккаунт может быть изменен через службу поддержки',
        removeOnlinePrinterTooltip: 'Нельзя удалить онлайн принтер. Сначала выключите его'
      },
      sharePrinter: {
        ownerCantBeDeleted: 'Владелец принтера не может быть удален',
        emailsToAllow: 'Электронные адреса...',
        limit: 'лимит',
        add: 'Добавить',
        notExists: 'Не существует',
        emailDoesNotBelong: 'Эта электронная почта не принадлежит ни одному пользователю DiaPrint. Вы можете пригласить его и поделиться принтером.',
        notMemberOfOrg: 'Не является членом организации',
        notMemberOfOrgDesc: 'Этот пользователь не является членом вашей организации. Ограничения на печать не будут действовать для него.',
        invite: 'Пригласить',
        accept: 'Подтвердить',
        inviteAll: 'Пригласить всех',
        acceptAllNonOrg: 'Подтвердить всех (не членов организации)',
        owner: 'Владелец',
        limitless: 'безлимит',
        limitNumber: 'лимит %{number}',
        confirmUnshare: 'Вы уверены, что хотите отвязать принтер?',
        errorUnsharePrinter: 'Ошибка удаления принтера',
        errorEmailDontBelong: 'Этот адрес электронной почты не принадлежит ни одному пользователю',
        errorNotMember: 'Пользователь не является членом Вашей организации',
        invalidEmail: 'Неверный адрес электронной почты'
      },
      workgroupAccess: {
        desc: 'Please enter Workgroup access code you received from your teacher or 3D printing laboratory administrator.',
        noCodeDesc: 'If you don\'t have Workgroup access code for your university,  please ask it from course teacher or 3Dprinting Lab administrator.',
        accessCode: 'Access code',
        notJoinedEducationalProgram: 'If your university has not yet joined the 3DPrinterOS Educational program please fill in <a href="%{quoteLink}" target="_blank">this form</a>, and we will help your university to make printers accessible for students.'
      },
      add_imprinta_printer: {
        title: 'Добавить новый принтер',
        enter_serial_number: 'Чтобы добавить принтер, введите его серийный номер',
        serial_number: 'Серийный номер',
        activate_printer: 'Ваш принтер еще не был активирован. Введите ПИН код <br /> на сенсорном экране принтера.<br/>После подключения к интернету принтер будет доступен для печати в облаке<br/><div class="printer-pin-code">%{hash}</div>',
        printer_added: 'Принтер был успешно добавлен в Ваш аккаунт.<br />После подключения к интернету принтер будет доступен для печати в облаке',
        failedToAdd: 'Ошибка добавления принтера',
        wrongSerialNumber: 'Неверный серийный номер',
        serialnumberWasRegistered: 'Этот серийный номер уже зарегистрирован',
      },
      printerLog: {
        close: 'Закрыть'
      }
    },
    shareRoles: {
      canPrint: 'Разрешена печать',
      canPrintCustom: 'Разрешена печать (custom)',
      canQueueCustom: 'Разрешена очередь (custom)',
      canQueue: 'Разрешена очередь',
      unknown: 'Неизвестно'
    }
  },
  history: {
    nav: {
      me: 'Моя',
      org: 'Организационная',
      search: 'Поиск по имени печати, пользователю, принтеру'
    },
    stat: {
      hoursPrinted: 'Напечатано(часов)',
      prints: 'Количество запусков',
      printing: 'Печатается',
      inQueue: 'В очереди',
      errors: 'Ошибки',
      materialsUsed: 'Использовано пластика (кг)'
    },
    noResult: 'Нету результатов',
    by: '',
    ownEmail: 'мною',
    actions: {
      restart: 'Печать заново',
      details: 'Детали',
      notes: 'Заметки',

    }
  },
  dateRangePicker: {
    selectDateRange: 'Выбрать промежуток дат',
    lastWeek: 'Посл. неделя',
    lastMonth: 'Посл. месяц',
    lastYear: 'Посл. год'
  },
  measure: {
    shortcut: {
      gram: 'г',
      millimeter: 'мм',
      meter: 'м',
      hours: 'ч'
    }
  },
  printTime: {
    estimated: 'оценочное',
    actual: 'фактическое',
    estimatedTime: 'Оценочное время',
  },
  userMenu: {
    storageAvailable: 'Доступно хранилища',
    bandwidthAvailable: 'Пропуская способность',
    superAdmin: 'Супер админ',
    organisationAdmin: 'Организационная админка',
    releaseNotes: 'История версий',
    myProfile: 'Мой профиль',
    customization: 'Кастомизация',
    oldDarkTheme: 'Темная старая тема',
    oldLightTheme: 'Светлая старая тема',
    newTheme: 'Новая тема beta',
    profileSettings: 'Настройки профиля',
    changePassword: 'Изменить пароль',
    logout: 'Выйти',
    licenseUnactivated: 'Лицензия не активирована'
  },
  notification: {
    printerNoSpace: 'На %{printerName} недостаточно свободной памяти чтобы запустить %{jobName}. Пожалуйста, удалите старые печати с экрана  %{jobName}.'
  },
  releaseNotes: {
    title: 'История версий',
    info: '<ul>\n' +
      '        <li>Интеграция Hegcules G2 в облако</li>\n' +
      '        <ul>\n' +
      '          <li>активация 3д принтера</li>\n' +
      '          <li>отправка файлов на печать, </li>\n' +
      '          <li>управление 3д принтером через облако, </li>\n' +
      '          <li>отслеживание локальной печати в облаке, </li>\n' +
      '          <li>стриминг изображения из камеры, </li>\n' +
      '          <li>стриминг лога принтера, </li>\n' +
      '          <li>стриминг статусов принтера, </li>\n' +
      '          <li>стриминг температуры экструдера и платформы.</li>\n' +
      '        </ul>\n' +
      '        <li>Загрузка и хранение файлов</li>\n' +
      '        <li>Хранение истории версий файлов в виде проектов</li>\n' +
      '        <li>Управление проектами</li>\n' +
      '        <li>Шеринг файлов и проектов</li>\n' +
      '        <li>Встроенные приложения: </li>\n' +
      '        <ul>\n' +
      '          <li>Волшебная палочка, </li>\n' +
      '          <li>STL редактор, </li>\n' +
      '          <li>GCODE визуализатор,  </li>\n' +
      '          <li>Gcode анализатор, STL рендер, </li>\n' +
      '          <li>GCODE рендер, </li>\n' +
      '          <li>Облачный слайсер на основе Cura 4.6. </li>\n' +
      '        </ul>\n' +
      '        <li>Управление печатями через облако:</li>\n' +
      '        <ul>\n' +
      '          <li>отправка файлов на печать, </li>\n' +
      '          <li>пауза, </li>\n' +
      '          <li>возобновление печати, </li>\n' +
      '          <li>копирование печатей, </li>\n' +
      '          <li>перезапуск, </li>\n' +
      '          <li>отслеживание статусов печати. </li>\n' +
      '        </ul>\n' +
      '        <li>Хранение и фильтрация истории печатей</li>\n' +
      '        <li>Генерация таймлапсов печати</li>\n' +
      '        <li>Отслеживание свободной платформы</li>\n' +
      '        <li>Управление занятостью платформы</li>\n' +
      '        <li>Шеринг принтеров внутри системы</li>\n' +
      '        <li>Создание, хранение и управление слайсинг профилями</li>\n' +
      '        <li>Имейл оповещения</li>\n' +
      '      </ul>'
  },
  userSettings: {
    auth2fa: 'Двухфакторная аутентификация',
    enabled2fa: 'Включена',
    disabled2fa: 'Выключена',
    enable2fa: 'Включить',
    disable2fa: 'Выключить',
    userInfo: 'Пользовательские данные',
    firstName: 'Имя',
    lastName: 'Фамилия',
    phone: 'Номер телефона',
    company: 'Компания',
    timezone: 'Часовой пояс',
    emailNotificationAfter: 'Получать email оповещения после',
    emailNotifications: {
      'Starting a print job': 'Печать началась',
      'New file is shared to you': 'С вами поделились файлом',
      'Printing video is generated': 'Видео печати сгенерировано',
      'New printer is shared to you': 'С вами поделились принтером',
      'New printer is logged into your account': 'Новый принтер подключен к аккаунту',
      'New project is shared to you': 'С вами поделились проектом'
    },
    saveSettings: 'Сохранить',
    settingsSavedSuccessfully: 'Данные аккаунта сохранены',
    disable2faSuccessfully: 'Двухфакторная аутентификация выключена',
    disable2faFailed: 'Ошибка при выключении двухфакторной аутентификации',
    changePassword: 'Изменить пароль',
    currentPassword: 'Старый пароль',
    newPassword: 'Новый пароль',
    retryNewPassword: 'Новый пароль повторно',
    passwordNotMatch: 'Повторно введенный пароль не совпадает',
    passwordChanged: 'Пароль успешно изменен',
    wrongPassword: 'Неверный пароль',
    failedChangePassword: 'Ошибка изменения пароля',
    wrongPasswordLength: 'В пароле должно быть не менее 8 символов'
  },
  orgAdmin: {
    navbar: {
      workgroupsAccess: 'Workgroups',
      workgroupPrinters: 'Printers',
      reports: 'Reports',
      users: 'Users',
      workflow: 'Workflow',
      settings: 'Settings',
      newWorkgroupsAccess: 'New workgroups access'
    },
    printers: {
      groups: 'Groups',
      delete: 'Delete'
    },
    workgroupsAccess: {
      manage: {
        tabs: {
          users: 'Users',
          printers: 'Printers',
          settings: 'General',
          wgadmins: 'Moderators'
        }
      },
      workgroup: {
        generate: 'Generate',
        accessCode: 'Access code',
        accessRights: 'Access rights',
        name: 'Name',
      },
      users: {
        add: 'Add',
      }
    },
    users: {
      addUser: 'Add User',
    }
  },
  modal2fa: {
    title: 'Активация двухфакторной аутентификации с помощью Google Authenticator',
    installGoogleAuth: 'Установите приложение Google Authenticator на вашем телефоне',
    openGoogleAuth: 'Откройте приложение Google Authenticator',
    goToQRCode: 'Перейдите в меню приложения, затем "Set up account", затем "Scan a QR-Code"',
    scanQRCode: 'Ваш телефон должен перейти в режиме сканирования. Отсканируйте QR-код приведенный ниже:',
    qrCode: 'QR-код',
    failedToLoadQRCode: 'Ошибка загрузки QR-кода',
    enterCode: 'После того, как вы отсканировали QR-код, введите 6-ти значный код, который отображен в приложении Google Authenticator:',
    verificationCode: 'Код верификации',
    enabledSuccessfully: 'Двухфакторная аутентификация установлена',
    failedToEnable: 'Ошибка при установке двухфакторной аутентификации'
  },
  router: {
    files: 'Файлы',
    projects: 'Проекты',
    profiles: 'Профили',
    printers: 'Принтеры',
    history: 'История',
    search: 'Поиск',
    download: 'Загрузка',
    account: 'Аккаунт',
    color: 'Цвет',
    liveViewWall: 'Live View Wall'
  },
  restorePassword: {
    title: 'Сбросить пароль',
    reset: 'Сбросить',
    success: 'Письмо с ссылкой для сброса пароля выслано на указанную электронную почту',
    error: 'Ошибка сброса пароля'
  },
  fileJobLog: {
    noJobs: 'Задачи не выполнялись для этого файла'
  },
  fileGcodeInfo: {
    printer: 'Принтер',
    nozzle: 'Сопло',
    nozzle1: 'Сопло 1',
    nozzle2: 'Сопло 2',
    layerHeight: 'Слой',
    infill: 'Заполнение',
    material: 'Материал',
    material1: 'Материал 1',
    material2: 'Материал 2',
    profile: 'Профиль',
    speed: 'Скорость',
    weight: 'Вес',
    weight1: 'Вес 1',
    weight2: 'Вес 2',
    textruder: 'Температура экструдера',
    textruder1: 'Температура экструдера 1',
    textruder2: 'Температура экструдера 2',
    ttable: 'Температура стола',
    tvolume: 'Температура термокамеры',
    fan: 'Обдув',
    printTime: 'Время печати',

    errorGetInfo: 'Ошибка при получении информации: %{msg}'
  },
  warningBox: {
    chrome: {
      text: 'Для достижения лучшего пользовательского опыта, мы рекомендуем использовать Google Chrome.',
      download: 'Скачать Chrome',
      hide: 'Спрятать'
    }
  },
  localeSelect: {
    lang: 'Язык',
  },
  footer: {
    cloud: '© DiaPrint облако',
    termsOfService: 'Условия использования',
    privacyPolicy: 'Политика конфиденциальности',
    poweredBy: 'При поддержке',
  },
  timezones: {
    0: '(GMT, no daylight saving) Стандартное'
  },
}
